import styled from 'styled-components';

import Button from '../../components/Button';
import InputField from '../../components/InputField';

export const PrivacyPolicy = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`;

PrivacyPolicy.FlexContainer = styled.div`
	padding: 16px;
`;

PrivacyPolicy.Container = styled.div`
	display: flex;
	flex-direction: column;

	@media only screen and (min-width: 600px) {
		max-width: 600px;
		margin: 2rem auto;
		padding: 32px;
	}
`;

PrivacyPolicy.Items = styled.div`
	padding: 1rem 2.5rem;
	@media only screen and (max-width: 600px) {
		padding: 0;
	}
`;

PrivacyPolicy.Title = styled.h2`
	font-style: normal;
`;

PrivacyPolicy.Subtitle = styled.h4`
	font-weight: 400;
	font-size: 16px;
	line-height: 20px;
	color: #26282A;
	margin-bottom: 0;
`;

PrivacyPolicy.Card = styled.div`
	background: #FFFFFF;
	box-shadow: 1px 2px 5px rgba(38, 40, 42, 0.16);
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 16px;
`;

PrivacyPolicy.Card.Title = styled.h3`
	font-weight: 500;
	font-size: 16px;
	margin: 0;
	line-height: 24px;
	color: #4E5255;
`;

PrivacyPolicy.Card.Company = styled.div`
	display: flex;
`;

PrivacyPolicy.Card.Company.Info = styled.div`
	display: flex;
	flex-direction: column
`;

PrivacyPolicy.Card.Company.Info.Name = styled.div`
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	color: #26282A;
`;

PrivacyPolicy.Card.Company.ContactInfo = styled.div``;

PrivacyPolicy.Card.Company.Info.Contact = styled.div`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #4E5255;
`;

PrivacyPolicy.Card.Company.Info.Address = styled.div`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #4E5255;
`;

PrivacyPolicy.Card.Company.Avatar = styled.img`
	width: 48px;
	height: 48px;
	object-fit: contain;
	border-radius: 50%;
	margin-right: 12px;
`;

PrivacyPolicy.Footer = styled.div`
	display: flex;
    flex: 1;
	height: 100%;
	padding: 16px;
	flex-direction: column;
`;

PrivacyPolicy.FooterContainer = styled.div`
	position: fixed;
	bottom: 0;
	width: 100%;
`;

PrivacyPolicy.Footer.Terms = styled.div`
	display: flex;
`;

PrivacyPolicy.Footer.Terms.Link = styled.a`
	text-decoration: none;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	padding-bottom: 1px;
	border-bottom: 1px solid;
	color: #008cff !important;
`;

PrivacyPolicy.Footer.AcceptedTerm = styled.div`
	display: flex;
`;

PrivacyPolicy.Footer.AcceptedTerm.Label = styled.label`
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	display: flex;
	align-items: center;
	color: #26282A;
`;

PrivacyPolicy.Footer.Button = styled(Button)`
	margin: 0 2rem !important;
	@media only screen and (max-width: 600px) {
		margin-top: 16px;
	}
`;

PrivacyPolicy.InputGroup = styled.div`
	display: flex;
	flex-direction: column
`;

PrivacyPolicy.Label = styled.label`
	font-weight: 700;
	font-size: 20px;
	margin-top: 32px;
	line-height: 24px;
	color: #26282A;
`;

PrivacyPolicy.InputField = styled(InputField)`
	margin-top: 24px;
	border: 1px solid #D9E1E8;
	width: 100%;
	height: 44px;
	padding: 8px;
	border-radius: 8px;
`;
